import AlertCircleIcon from 'app/ui_v2/icons/AlertCircleIcon';

import { Box } from '@mui/material';

export interface SwoInfoProps {
  type: 'error' | 'warning';
  text?: string;
}

export default function SwoInfo(props: SwoInfoProps) {
  const { type, text = 'Hold or Lock Restriction' } = props;

  const color = type === 'error' ? '#aa002c' : '#b05e11';

  return (
    <Box sx={{ display: 'flex', alignItems: 'center' }}>
      <AlertCircleIcon sx={{ fontSize: '2rem', color }} />
      <Box sx={{ ml: 0.5, fontSize: '1.4rem', color }}>{text}</Box>
    </Box>
  );
}
